<div fxLayout="row" fxLayoutAlign="center none">
  <div class="max-form-width">
    <mat-card>
      <mat-card-content>
        <form [formGroup]="userFormGroupControls" (ngSubmit)="onButtonClick()" class="basic-form">
          <div fxLayout="column wrap">
            <mat-form-field fxFlex>
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" [formControl]="form?.email">
              <mat-error *ngIf="form?.email.hasError('required')">
                Email is required
              </mat-error>
              <mat-error *ngIf="form?.email.hasError('pattern')">
                Invalid email address
              </mat-error>
            </mat-form-field>
            <div>
              <mat-form-field fxFlex>
                <mat-label>{{isUpdate ? 'Update' : 'Set'}} first name</mat-label>
                <input matInput placeholder="First Name" type="text" [formControl]="form?.firstName">
              </mat-form-field>
              <mat-form-field fxFlex>
                <mat-label>{{isUpdate ? 'Update' : 'Set'}} last name</mat-label>
                <input matInput placeholder="Last Name" type="text" [formControl]="form?.lastName">
              </mat-form-field>
            </div>
          
            <mat-form-field fxFlex>
              <mat-label>{{isUpdate ? 'Update' : 'Set'}} password</mat-label>
              <input matInput placeholder="Password" [type]="hidePassword ? 'password' : 'text'"
                [formControl]="form?.password">
              <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility_off' :
                'visibility'}}
              </mat-icon>
              <mat-error *ngIf="form?.password.hasError('pattern')">
                Password must contain at least 1 number and be at least 8 characters long
              </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="isAdmin || isSituUser" fxFlex>
              <mat-label>Select a company</mat-label>
              <mat-select [(value)]="user.companyId">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let comp of companies" [value]="comp.id">
                  {{ comp.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="isSituUser" fxFlex>
              <mat-label>Choose roles</mat-label>
              <mat-select multiple [formControl]="form?.roles">
                <mat-option *ngFor="let role of allRoles" [value]="role.id">
                  {{ role.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="isAdmin && !isSituUser" fxFlex>
              <mat-label>Choose roles</mat-label>
              <mat-select multiple [formControl]="form?.roles">
                <mat-option *ngFor="let role of adminAssignableRoles" [value]="role.id">
                  {{ role.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <tag-picker
              (addTagRequest)="addTag($event)"
              (removeTagRequest)="removeTag($event)"
              [allTags]="tags"
              [assignedTagIds]="user?.tagIds"
              [resourceType]="resourceTypeEnum"
              [allowAddTag]="false">
            </tag-picker>

            <div fxLayoutGap="20px">
              <div class="p-t-10 column" fxLayoutGap="20px">
                <div fxLayoutGap="15px">
                  <div fxFlex.gt-xs="200px" class="wrap">Username</div>
                  <div fxFlex>{{ user?.userName }}</div>
                </div>

                <div fxLayoutGap="15px">
                  <div fxFlex.gt-xs="200px">Failed login attempts</div>
                  <div fxFlex>{{ user?.accessFailedCount }}</div>
                </div>

                <div fxLayoutGap="15px">
                  <div fxFlex.gt-xs="200px">Email confirmed</div>
                  <div fxFlex>{{ user?.emailConfirmed ? "&#10003;" : "&#10007;" }}</div>
                </div>
              </div>

              <div fxLayout="row" class="p-t-20" fxLayoutGap="15px">
                <div *ngIf="isSituUser" fxFlex.gt-xs="200px">
                  <mat-checkbox [formControl]="form?.isEnabled" id="isEnabled">
                    User enabled
                  </mat-checkbox>
                </div>
                <div fxFlex>
                  <mat-checkbox [formControl]="form?.lockoutEnabled" id="lockoutEnabled">
                    Locked out
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div fxLayoutAlign="end center" fxLayoutGap="15px" class="p-t-20">
            <button type="button" *ngIf="showViewAs" mat-flat-button color="accent" (click)="onClickViewAsUser()">
              <mat-icon>badge</mat-icon> View As
            </button>
            <button *ngIf="submitAction.toString() == 'Save'" type="button" mat-flat-button color="warn" title="Delete"
              (click)="onDeleteClick()">
              <mat-icon>delete</mat-icon>Delete
            </button>
            <button type="submit" mat-flat-button color="primary" title="Save"
              [disabled]="!this.userFormGroupControls?.valid">
              <mat-icon>{{submitAction.toString() == "Save" ? 'done' : 'add'}}</mat-icon>
              {{submitAction.toString()}}
            </button>
          </div>
        </form>
        
      </mat-card-content>
    </mat-card>
  </div>
</div>
